<script lang="ts">
  import { cn } from '@shared/utils';

  export let href: string | undefined = undefined;
  export let target: '_self' | '_blank' | '_parent' | '_top' | undefined = undefined;
</script>

<svelte:element
  this="{href ? 'a' : 'button'}"
  {href}
  {target}
  role="button"
  tabindex="0"
  class="
      {cn(
    'text-default-900 hover:text-default-50 bg-default-900/10 dark:bg-default-200/20 dark:hover:bg-default-200/100 dark:text-dark-900 dark:hover:text-default-900 hover:bg-default-900 relative rounded-lg px-3 py-2 text-sm font-medium transition-colors',
  )}
    "
  on:click
>
  <slot />
</svelte:element>
